<div class="section-title text-center">
    <h2>Unsere Kurse</h2>
    <div class="bar mx-auto"></div>
    <p>Informiere dich über unsere aktuellen Kursangebote – ideal für Theorie, Praxis und Ferienkurse.</p>
</div>

<div class="row">
    <div class="col-lg-4 col-md-6 mb-4" *ngFor="let kurs of kurse">
    <div class="card h-100 shadow-sm border-0">
        <div class="card-body">
        <h5 class="card-title">{{ kurs.name }}</h5>
        <p><strong>Datum:</strong> {{ kurs.datum }}</p>
        <p><strong>Uhrzeit:</strong> {{ kurs.uhrzeit }}</p>
        <p><strong>Ort:</strong> {{ kurs.ort }}</p>
        </div>
    </div>
    </div>
</div>
  